module.exports = __webpack_public_path__ + "img/wizard.23c2ad21.jpg";